/**
 * 311即时订货查询模块接口列表
 */
import Vue from "vue"
import axios from '@/utils/http'; // 导入http中创建的axios实例
const storder = {
    //页面初始化
    init() {
        return axios.get(`${Vue.prototype.$base.API_PATH}/instant/storder/inittemplate`);
      },
      //得到311订货查询数据集合
      list(params) {
        return axios.get(`${Vue.prototype.$base.API_PATH}/instant/storder/list`, { params: params});
      },
      //得到订货日期的选项数据
      orderDateOptions() {
        return axios.get(`${Vue.prototype.$base.API_PATH}/instant/storder/date`);
      },
      //ciy用户检索后，当前页的所有数据的查看状态全部改为已查看
      operationFlgUpdate(params) {
        return axios.post(`${Vue.prototype.$base.API_PATH}/instant/storder/operation-flg`, params);
      },
      //打印信息
      print(params) {
        return axios.get(`${Vue.prototype.$base.API_PATH}/instant/storder/print`,{ params: params});
      },
      //供应商打印后，把选中数据的打印状态全部改为已打印
      printFlgUpdate(params) {
        return axios.post(`${Vue.prototype.$base.API_PATH}/instant/storder/print-flg`, params);
      },
    //查询员编的订货数量
    countByPerson(params) {
      return axios.get(`${Vue.prototype.$base.API_PATH}/instant/storder/count-person`,{ params: params});
    },
}

export default storder;



// WEBPACK FOOTER //
// ./src/api/storder.js